var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnUtenti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.5 50.5",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "followers",
    transform: "translate(-.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    transform: "translate(.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    className: "st0",
    d: "M23.1 46.5H5.9c-1.1 0-2-.9-2-2 0-.2 0-.4.1-.6 2.1-6.2 7.9-10.3 14.5-10.3 3 0 6 .9 8.5 2.7.9.6 2.1.4 2.7-.5.6-.9.4-2.1-.5-2.7-1.2-.9-2.5-1.6-3.9-2.1 1.9-1.7 3.1-4.1 3.3-6.6 5.1-5 13-5.6 18.8-1.5.9.6 2.1.4 2.7-.5.6-.9.4-2.1-.5-2.7-1.2-.9-2.5-1.6-3.9-2.1 4.1-3.7 4.4-10.1.7-14.2s-10.1-4.6-14.2-.9-4.4 10.1-.7 14.2c.2.2.4.5.7.7-.3.1-.5.2-.8.3-1.2.5-2.4 1.2-3.5 2-2.1-5.2-7.9-7.7-13.1-5.6S7.1 22 9.2 27.2c.6 1.4 1.4 2.7 2.5 3.7-5.4 2-9.6 6.3-11.5 11.8-1 3.1.7 6.4 3.8 7.4.6.2 1.2.3 1.8.3H23c1.1 0 2-.9 1.9-2 .1-1.1-.8-1.9-1.8-1.9zM39 3.9c3.4 0 6.1 2.7 6.1 6.1s-2.7 6.1-6.1 6.1c-3.4 0-6.1-2.7-6.1-6.1-.1-3.4 2.7-6.1 6.1-6.1zM18.5 17.4c3.4 0 6.1 2.7 6.1 6.1s-2.7 6.1-6.1 6.1-6.1-2.7-6.1-6.1c0-3.4 2.8-6.1 6.1-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    className: "st0",
    d: "M49.7 32.1c-.9-.6-2.1-.4-2.8.5l-9.7 13.6c-.4.5-1.1.5-1.6.1l-6.3-6c-.8-.7-2.1-.7-2.8.1-.7.8-.7 2 .1 2.7l6.3 6c.9.9 2.2 1.4 3.5 1.4h.3c1.4-.1 2.7-.8 3.6-1.9 0 0 0-.1.1-.1l9.8-13.6c.6-.9.3-2.1-.5-2.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUtenti);
export default __webpack_public_path__ + "static/media/icn_utenti.1f8fe0b6787a2bfe7d89dc0794423ebe.svg";
export { ForwardRef as ReactComponent };